import React, { useState } from 'react';
import classNames from 'classnames';
import { Cross } from '@saleshandy/icons';
import Modal from '../../../shared/design-system/components/atoms/modal';
import Button from '../../../shared/design-system/ui/button';
import { AnalyticsEvents } from '../../../shared/enums/analytics';
import {
  getUserShAccountId,
  getUserTrackingId,
} from '../../../shared/utils/user-details';
import { setIsDemoFeedbackSubmitted } from '../../../shared/utils';
import { accessibleOnClick } from '../../../shared/utils/accessible-on-click';

type IProps = {
  show: boolean;
  onClose: () => void;
};

const FeedbackModal: React.FC<IProps> = ({ show, onClose }) => {
  const [selectedOption, setSelectedOption] = useState<'yes' | 'no' | null>(
    null,
  );
  const [feedback, setFeedback] = useState('');

  const isSubmitDisabled = !selectedOption;

  const handleOnClose = () => {
    setIsDemoFeedbackSubmitted();
    onClose();
  };

  return (
    <Modal
      show={show}
      hideHeader
      hideFooter
      backdrop="static"
      extraModalProps={{
        centered: true,
        'aria-labelledby': 'contained-modal-title-vcenter',
      }}
      className="feedback-modal--wrapper"
      showCloseIcon={true}
      onClose={handleOnClose}
    >
      <>
        <div
          className="feedback-modal--cross"
          {...accessibleOnClick(handleOnClose)}
        >
          <Cross />
        </div>
        <div className="feedback-modal--title">
          Was the Demo Account helpful?
        </div>
        <div className="d-flex gap-16 justify-center mb-24">
          <button
            className={classNames('feedback-modal--option', {
              active: selectedOption === 'yes',
            })}
            onClick={() => setSelectedOption('yes')}
            type="button"
          >
            <span>Yes</span>
          </button>
          <button
            className={classNames('feedback-modal--option', {
              active: selectedOption === 'no',
            })}
            onClick={() => setSelectedOption('no')}
            type="button"
          >
            <span>No</span>
          </button>
        </div>

        <textarea
          className="feedback-modal--textarea"
          placeholder={
            selectedOption === 'no'
              ? 'What did you expect but didn’t find?'
              : 'Awesome! Anything we can add to make it even better?'
          }
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        />

        <Button
          className="feedback-modal--feedback-submit-btn"
          disabled={isSubmitDisabled}
          onClick={() => {
            window.analytics?.track?.({
              userId: getUserTrackingId(),
              event: AnalyticsEvents.DemoFeedbackSubmitted,
              properties: {
                shAccountId: getUserShAccountId(),
                response: selectedOption,
                follow_up_text: feedback,
              },
            });
            setIsDemoFeedbackSubmitted();
            onClose();
          }}
        >
          Submit
        </Button>
      </>
    </Modal>
  );
};

export default FeedbackModal;
